import iconCrossSvg from './assets/icon__cross.svg';

export const config = {
    baseHtmlClass: `popover_window__closebox`,
    selector: '.popover_window__closebox',
    hiddenModifier: 'hidden',

    closeboxSvg: iconCrossSvg
}

export class popoverWindowClosebox {

    static createElement() {
        let element = document.createElement('div');
        element.setAttribute("class", popoverWindowClosebox.htmlClasses());
        element.innerHTML = config.closeboxSvg;
        return element;
    }

    static htmlClasses() {
        const baseClass = config.baseHtmlClass;
        let classes = [ baseClass, `${ baseClass }--${ config.hiddenModifier }` ];
        return classes.join(' ');
    }

    constructor(element, popoverWindow){
        this.config = config;
        this.popOverWindow = popoverWindow;
        this.element = element;
        this.listen();
    }

    listen(){
        this.element.addEventListener('click', (event) => {
            this.popOverWindow.closePopover(event);
            event.preventDefault();
            event.stopPropagation();
        })
    }

    show() {
        this.removeState(config.hiddenModifier);
    }

    hide() {
        this.addState(config.hiddenModifier)
    }

    addState(state) {
        this.element.classList.add(`${config.baseHtmlClass}--${state}`);
    }

    removeState(state) {
        this.element.classList.remove(`${config.baseHtmlClass}--${state}`);
    }

}
